module.exports = __webpack_public_path__ + "img/partyManage.8305a11a.png";